import React from 'react';

interface SelectedCabCardProps {
  cabType?: string;
  maxOccupancy?: number;
  transferType?: string;
}

const SelectedCabCard: React.FC<SelectedCabCardProps> = ({
  cabType,
  maxOccupancy,
  transferType,
}) => {
  const vehicleLabel = String(cabType || '').trim() || 'Selected Cab';
  const occupancy = Number(maxOccupancy || 0);
  const occupancyLabel = occupancy > 0 ? `${occupancy} passenger${occupancy > 1 ? 's' : ''}` : 'Occupancy to be confirmed';

  return (
    <div style={{
      border: '1px solid #e1e5e9',
      borderRadius: '12px',
      padding: '16px',
      marginBottom: '16px',
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      display: 'flex',
      gap: '16px',
    }}>
      <div style={{ flex: '0 0 80px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '8px',
          border: '2px solid #e9ecef',
          overflow: 'hidden',
        }}>
          <img
            src="https://cdn.otaprime.com/cab-color.png"
            alt="Cab icon"
            style={{
              width: '48px',
              height: '48px',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </div>
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ marginBottom: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
              {vehicleLabel}
            </h4>
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '12px',
          padding: '12px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
        }}>
          <div>
            <div style={{ fontSize: '10px', color: '#6c757d', marginBottom: '2px' }}>Cab Type</div>
            <div style={{ fontSize: '12px', fontWeight: '500' }}>{vehicleLabel}</div>
          </div>
          <div>
            <div style={{ fontSize: '10px', color: '#6c757d', marginBottom: '2px' }}>Max Occupancy</div>
            <div style={{ fontSize: '12px', fontWeight: '500' }}>{occupancyLabel}</div>
          </div>
        </div>
        <div style={{
          fontSize: '10px',
          color: '#6c757d',
          lineHeight: '1.35',
          marginTop: '8px',
        }}>
          <div style={{ fontWeight: 600, marginBottom: '6px', textAlign: 'left' }}>Transfer Inclusions</div>
          <ul style={{
            margin: 0,
            paddingLeft: '18px',
            textAlign: 'left',
            listStylePosition: 'outside',
            display: 'grid',
            gap: '4px',
          }}>
            <li>Pickup from airport on private basis</li>
            <li>Intercity or hotel transfers on private basis as per itinerary</li>
            <li>Sightseeing on private basis</li>
            <li>Drop to airport on private basis</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SelectedCabCard;
